"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseUserAppStrategy = void 0;
const auth_credential_util_1 = require("../../../@common/util/auth-credential-util");
const config_1 = __importDefault(require("../../config"));
const gatekeeper_api_1 = __importDefault(require("../../api/gatekeeper-api"));
const user_api_1 = __importDefault(require("../../../@api/user-api"));
const { services: { userLogin: { url: USER_LOGIN_URL } } } = config_1.default;
const BaseUserAppStrategy = ({ path }) => {
    const creds = (0, auth_credential_util_1.getAuthCredentials)();
    return {
        authValue: !creds.authToken || !creds.username ? null : creds,
        authenticate: gatekeeper_api_1.default.authLwt,
        getUser: user_api_1.default.getUser,
        loginUrl: `${USER_LOGIN_URL}/${path}?returnURL=${window.location.href}`
    };
};
exports.BaseUserAppStrategy = BaseUserAppStrategy;
